export default () => {
    const homePage = $(".type-index").length;

    if (homePage) {
        // Remove reviews if any
        var reviewDiv = $(".overall-wrapper .content-wrapper.latest-contribution-box");
        reviewDiv.remove();

        var isMobile = isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
        var videoSrc = isMobile ? "/user/documents/video/DraftV5_Vertical.mp4" : "/user/documents/video/video-homepage-v6.mp4"

        // Instagram icon
        var instagramIcon = `
        <div class="instagram-icon-wrapper">
            <a target="_blank" href="https://www.instagram.com/theminerscoffee/">
                <img class="instagram-icon" src="/user/documents/img/inst2022.svg" />
            </a>
        </div>
        `
        $("#header .navigation-wrapper .header-top .languagesMenu").after(instagramIcon);

        // Video
        var videoBlock = `
        <div class="homepage-video-block">
            <video muted playsinline autoplay loop src="${videoSrc}" class="homepage-video" />
        </div>
        `
        $(".type-index .overall-wrapper .content-wrapper").append(videoBlock);
    }
};